export default __webpack_public_path__ + "static/media/pngwing.com (2).27b79199.png";